import * as React from 'react';
import {
    Col,
    Row,
} from 'reactstrap';

import { BasicUserErrorMessages, BasicUserDetails } from './BasicUserDetails';
import { UserRoleSelection } from './UserRoleSelection';

import {
    CreateUserRequest,
    RoleResponse,
    ResourceRole,
    PortalTextSettings,
} from '../../../Models/Api/strongbox.financialportal';
import { PermissionsPopoverTarget } from './PermissionsPopover';

export type CollectUserInfoPermissionsProps = {
    availableRoles: RoleResponse[];
    currentRoles: ResourceRole[];
    permissionsPopoverTarget?: PermissionsPopoverTarget;
    showDescriptionPopover: (role: RoleResponse, target: string) => void;
    onRoleChanged: (role: RoleResponse, checked: boolean) => void;
}

type Props = {
    user: CreateUserRequest;
    errorMessages?: BasicUserErrorMessages;
    onUpdateUser: (user: CreateUserRequest) => void;
    permissionProps?: CollectUserInfoPermissionsProps;
    emailDomainsForTenant: string[];
    updateUserProps: (newUserInfo: CreateUserRequest) => void;
    emailWellFormed: boolean;
    emailErrorMessage: boolean;
    focusRef: any;
    settingsText?: PortalTextSettings;
}

export const EditRequiredUserInfo: React.FC<Props> = (props): React.ReactElement => {
    const {
        emailDomainsForTenant,
        errorMessages,
        permissionProps,
        user,
        updateUserProps,
        emailWellFormed,
        emailErrorMessage,
        focusRef,
        settingsText,
    } = props;

    return (
        <React.Fragment>
            <Row className={'std-form-row'}>
                <h4>{settingsText?.addUserEnterNewUserInformation || ''}</h4>
            </Row>
            <Row>
                <Col>
                    <BasicUserDetails
                        errorMessages={errorMessages}
                        user={{
                            firstName: user.firstName,
                            lastName: user.lastName,
                            emailAddress: user.emailAddress,
                        }}
                        onChange={(newValue) => {
                            updateUserProps({
                                ...user,
                                lastName: newValue.lastName,
                                firstName: newValue.firstName,
                                emailAddress: newValue.emailAddress,
                            })
                        }}
                        focusRef={focusRef}
                        stackLabels={true}
                        emailDomainsForTenant={emailDomainsForTenant}
                        showEmailDomainError={emailErrorMessage}
                        emailValid={emailWellFormed && !emailErrorMessage}
                        settingsText={settingsText}
                    />
                </Col>
                {!!permissionProps && (
                    <Col>
                        <UserRoleSelection
                            availableRoles={permissionProps.availableRoles}
                            currentRoles={permissionProps.currentRoles}
                            disabled={false}
                            disableDescriptions={!!permissionProps.permissionsPopoverTarget}
                            showDescriptionPopover={permissionProps.showDescriptionPopover}
                            onChanged={permissionProps.onRoleChanged}
                            settingsText={settingsText}
                        />
                    </Col>
                )}
            </Row>
        </React.Fragment>
    );
}
